export default {
  getNotice: state => noticeId => state.notices.find(notice => notice.id === noticeId),
  unseen: state => state.notices.filter(notice => notice.state === 'unseen'),

  totalPages: state => {
    return Math.ceil(state.noticesCount / state.limit)
  },
  currentPage: state => {
    return Math.ceil(state.skip / state.limit + 1)
  }
}
